import $ from 'jquery';
import { buildGuideEmbedUrl, getGuideTopicForPath } from './helpTopics';
import {
  closeGuidePanel,
  toggleGuidePanel,
  toggleGuidePanelWidth,
} from './panel';
import { GUIDE_SURFACE_PRIVATE_NAVBAR } from './config';

const getCurrentTopicSlug = () =>
  getGuideTopicForPath(window.location.pathname);

export const initGuideUi = () => {
  $('body')
    .off('click.guide', '[data-guide-launcher]')
    .on('click.guide', '[data-guide-launcher]', function (event) {
      event.preventDefault();
      toggleGuidePanel(
        $(this).data('guideSurface') || GUIDE_SURFACE_PRIVATE_NAVBAR,
        buildGuideEmbedUrl(getCurrentTopicSlug())
      );
    });

  $('body')
    .off('click.guide', '[data-guide-close]')
    .on('click.guide', '[data-guide-close]', function (event) {
      event.preventDefault();
      closeGuidePanel();
    });

  $('body')
    .off('click.guide', '[data-guide-resize]')
    .on('click.guide', '[data-guide-resize]', function (event) {
      event.preventDefault();
      toggleGuidePanelWidth();
    });
};
